import { render, staticRenderFns } from "./TransactionPage.vue?vue&type=template&id=04030eaa&scoped=true"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"
import style0 from "./TransactionPage.vue?vue&type=style&index=0&id=04030eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04030eaa",
  null
  
)

export default component.exports